import React from 'react';
import {IOrderLogModel, OrderLogPossibleTypes} from '@src/@interfaces/models/Order/IOrderLogModel';
import {FormFieldOption} from '@src/@types/components/Form';
import {OrderCreated} from './OrderCreated';
import {OrderStatusChanged} from './OrderStatusChanged';
import {OrderTrashed} from './OrderTrashed';
import {OrderRestored} from './OrderRestored';
import {OrderProductCreated} from './OrderProductCreated';
import {OrderProductStatusChanged} from './OrderProductStatusChanged';
import {OrderProductDeleted} from './OrderProductDeleted';
import {OrderManagerChanged} from './OrderManagerChanged';
import {OrderMarkedAsCompleted} from './OrderMarkedAsCompleted';
import {OrderProductMarkedAsCompleted} from './OrderProductMarkedAsCompleted';
import {OrderProductApprovalAccepted} from './OrderProductApprovalAccepted';
import {OrderProductApprovalDeclined} from './OrderProductApprovalDeclined';
import {TypicalMessageProps} from './TypicalMessage';
import {OrderDeadlineChanged} from './OrderDeadlineChanged';
import {OrderProductDeadlineChanged} from './OrderProductDeadlineChanged';
import {OrderTaskCreated} from './OrderTaskCreated';
import {DateTime} from '@src/@types/DateTime';
import {parseDate} from '@src/helpers/dates';
import {OrderTaskPayloadStatusChanged} from './OrderTaskPayloadStatusChanged';
import {OrderTaskPayloadChangeAtChanged} from './OrderTaskPayloadChangeAtChanged';
import {OrderTaskTrashed} from './OrderTaskTrashed';
import {OrderTaskDeleted} from './OrderTaskDeleted';
import {OrderChecklistItemChecked} from '@views/orders/fields/logs/messages/OrderChecklistItemChecked';
import {OrderChecklistChecked} from '@views/orders/fields/logs/messages/OrderChecklistChecked';
import {OrderProductChecklistItemChecked} from '@views/orders/fields/logs/messages/OrderProductChecklistItemChecked';
import {OrderProductChecklistChecked} from '@views/orders/fields/logs/messages/OrderProductChecklistChecked';
import {
    OrderProductMarkedAsIgnoredByOrderPrice
} from '@views/orders/fields/logs/messages/OrderProductMarkedAsIgnoredByOrderPrice';
import {
    OrderProductUnMarkedAsIgnoredByOrderPrice
} from '@views/orders/fields/logs/messages/OrderProductUnMarkedAsIgnoredByOrderPrice';

const map: Record<OrderLogPossibleTypes, React.ComponentType<TypicalMessageProps<any>>> = {
    'order.created': OrderCreated,
    'order.status-changed': OrderStatusChanged,
    'order.manager-changed': OrderManagerChanged,
    'order.trashed': OrderTrashed,
    'order.restored': OrderRestored,
    'order-product.created': OrderProductCreated,
    'order-product.status-changed': OrderProductStatusChanged,
    'order-product.deleted': OrderProductDeleted,
    'order.marked-as-completed': OrderMarkedAsCompleted,
    'order-product.marked-as-completed': OrderProductMarkedAsCompleted,
    'order-product.approval-accepted': OrderProductApprovalAccepted,
    'order-product.approval-declined': OrderProductApprovalDeclined,
    'order.deadline-changed': OrderDeadlineChanged,
    'order-product.deadline-changed': OrderProductDeadlineChanged,
    'order-task.change-status.created': OrderTaskCreated,
    'order-task.change-status.status-changed': OrderTaskPayloadStatusChanged,
    'order-task.change-status.change-at-changed': OrderTaskPayloadChangeAtChanged,
    'order-task.change-status.trashed': OrderTaskTrashed,
    'order-task.change-status.deleted': OrderTaskDeleted,
    'order.checklist-item-marked-as-checked': OrderChecklistItemChecked,
    'order.checklist-marked-as-checked': OrderChecklistChecked,
    'order-product.checklist-item-marked-as-checked': OrderProductChecklistItemChecked,
    'order-product.checklist-marked-as-checked': OrderProductChecklistChecked,
    'order-product.marked-as-ignored-by-price': OrderProductMarkedAsIgnoredByOrderPrice,
    'order-product.unmarked-as-ignored-by-price': OrderProductUnMarkedAsIgnoredByOrderPrice,
};

export const toDate = (item: DateTime | undefined | null): string => {
    return item == null ? '—' : parseDate(item).format('LLL');
};

export function renderOrderLogMessageRepresentation(
        orderLog: IOrderLogModel,
        options: Record<string, FormFieldOption[]>,
) {
    const type = orderLog.message_details['@type'] as keyof typeof map;
    const Component = map[type] ?? null;
    if (!Component) {
        return null;
    }

    return <Component model={orderLog} options={options}/>;
}
